export default __webpack_public_path__ + "static/media/prev-icon.fc6db133.svg";